export default __webpack_public_path__ + "static/media/reach-us.6d46c11b.PNG";